export const RECEIVE_AGENT = 'RECEIVE_AGENT';
export const DONE = 'DONE';
export const ERROR = 'ERROR';
